import {React, useState, useEffect} from "react";
import { Container, Row, Col } from 'react-bootstrap';
import './ImageGrid.css';
import {Helmet} from "react-helmet";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import config from "../includes/ConfigFile";

const Category = () => {
    

const { categoryName } = useParams();
const { languageId } = useParams();
const [categoryData,setcategoryData] = useState([]);
console.log("Category Name:", categoryName);
console.log("Language ID:", languageId);
    useEffect( () => {
        axios.get(`${config.BASE_URL}/api/posts/${categoryName}/${languageId}`)
        .then(response => {
            setcategoryData(response.data);
           // console.log(response.data);
        })
        .catch(error => {
            console.error('Error fetching data :', error);
        });
    },[categoryName, languageId] );
    return (
        <>
        <Helmet>
                <meta charSet="utf-8" />
                <title>Category </title>
                <link rel="canonical" href="http://mysite.com/example" />
                <meta name="description" content="Helmet application" />
            </Helmet>
        <Container className="image-grid-container">
      <Row>
        {categoryData.map((category, index) => (
          <Col key={index} xs={6} sm={4} md={2} className="mb-4">
            <Link to={`/story/${category.id}`} className="text-decoration-none">
            <div className="image-item">
              <img 
                src={`${config.BASE_URL}/public/uploads/admin/post/${category.post_image}`}  
                alt={category.post_title} 
                className="img-fluid"
              />
              <h5 className="image-title mt-2">{category.post_title}</h5>
            </div>
            </Link>
          </Col>
        ))}
      </Row>
      
    </Container>
        </>

    );
};

export default Category;